import React from "react";
const text = {
    en: {
        title: "Something Went Wrong!",
        please_try: "Please try to",
        page: "the page",
        refresh: "refresh"
    },
    ar: {
        title: "حدث خطأ!",
        body: "يرجى محاولة </span>تحديث<span> الصفحة",
        please_try: "يرجى محاولة",
        page: "الصفحة",
        refresh: "تحديث"
    }
};
const MainContainer = (props) => {
    let Header = () => React.createElement(React.Fragment, null);
    return (React.createElement(React.Fragment, null,
        React.createElement(Header, null),
        props.children));
};
export default MainContainer;
